import api from "./api.config";
const list = (params) => {
    
    return api
        .get(`/api/admin/channels`, {
            params
        })
        .then((response) => {
            return response.data;
        });
}

const listAsOptions = () => {
    
    return list({
        limit: 100,
        page: 1
    }).then((response) => {
        const options = response.data.map(channel => ({
            key: channel.id,
            value: channel.name
        }));
        return options;
    });
}

const ChannelsService = {
    list,
    listAsOptions
};

export default ChannelsService;